module.exports = __webpack_public_path__ + "static/img/2_2_1.7ad0b999.jpg";